<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">검색 키워드 순위 10</span>
      </caption>
      <colgroup>
        <col width="150px" />
      </colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="2">순위</th>
          <th colspan="4">마음체조</th>
        </tr>
        <tr>
          <th colspan="2">성공 키워드</th>
          <th colspan="2">실패 키워드</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <tr>
        <td>{{rowData.rank}}</td>
        <!-- 마음체조 성공 -->
        <template v-if="rowData.mindGymSuccess">
          <td>{{rowData.mindGymSuccess.keyword}}</td>
          <td>{{rowData.mindGymSuccess.keywordCount}}</td>
        </template>
        <template v-else>
          <td v-for="i in 2">-</td>
        </template>
        <!-- 마음체조 실패 -->
        <template v-if="rowData.mindGymFail">
          <td>{{rowData.mindGymFail.keyword}}</td>
          <td>{{rowData.mindGymFail.keywordCount}}</td>
        </template>
        <template v-else>
          <td v-for="i in 2">-</td>
        </template>
      </tr>
    </template>
  </PlainTable>
</template>

<script>
export default {
  props: {
    itemArray: Array
  }
};
</script>
